import { h } from 'preact';
import { useState, useRef, useEffect } from 'preact/hooks';
import styles from './SortDropdown.module.scss';
export function SortDropdown({ options, currentSort, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    // Default to first option if currentSort is not set
    const defaultSort = currentSort || (options.length > 0 ? options[0].id : '');
    const selectedOption = options.find(opt => opt.id === defaultSort);
    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [isOpen]);
    const handleSelect = (optionId) => {
        onChange(optionId);
        setIsOpen(false);
    };
    return (h("div", { class: styles.sortDropdown, ref: dropdownRef },
        h("label", { class: styles.sortLabel }, "Sort by"),
        h("div", { class: styles.customSelect },
            h("button", { class: styles.selectButton, onClick: () => setIsOpen(!isOpen), "aria-haspopup": "listbox", "aria-expanded": isOpen },
                h("span", null, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label),
                h("svg", { class: isOpen ? styles.arrowOpen : styles.arrow, width: "12", height: "7", viewBox: "0 0 12 7", fill: "none" },
                    h("path", { d: "M5.65375 6.7075L0 1.05375L1.05375 0L5.65375 4.6L10.2537 0L11.3075 1.05375L5.65375 6.7075Z", fill: "#474747" }))),
            isOpen && (h("ul", { class: styles.optionsList, role: "listbox" }, options.map(option => (h("li", { key: option.id, class: option.id === defaultSort ? styles.optionActive : styles.option, onClick: () => handleSelect(option.id), role: "option", "aria-selected": option.id === defaultSort }, option.label))))))));
}
